let en = {
  Title: "Advantage",
  Content: [
    {name: 'Stable', desc: 'Based on widely used, market-proven public blockchain.'},
    {name: 'Efficient', desc: 'Fast business smart contract deployment, codeless blockchain service integration.'},
    {name: 'Scalable', desc: 'Protocol-oriented architecture provides seamless cross-chain interoperability.'},
  ],
}

let zh = {
  Title: '优点',
  Content: [
    {name: '稳定', desc: '基于经过市场验证的成熟公链进行业务开发。'},
    {name: '高效', desc: '快速业务合约部署，无编码区块链服务集成。'},
    {name: '可扩展', desc: '面向协议的业务架构提供了无缝的跨链互操作性。'},
  ],
}

let name = 'Advantage'

export default {
  name,
  en,
  zh
}